<template>
  <a-result :title="title">
    <template #extra>
      <a-button type="primary" @click="toHome">返回首页</a-button>
      <a-button v-if="productId > 0" key="buy"  @click="toBuy">前往购买</a-button>
    </template>
  </a-result>
</template>

<script>
  export default {
    name: 'NotPermission',
    data () {
      return {
        title: '',
        productId: 0,
      }
    },
    created() {
      this.title = this.$route.query.title || '服务繁忙，请售后重试';
      this.productId = this.$route.query.product_id || 0;
    },
    methods: {
    toHome () {
      this.$router.push({ path: '/' })
    },
    toBuy () {
      const url = `/product/detail?id=${this.productId}`;
      this.$router.push({ path: url })
    }
  }
  }
</script>

